// Central registry of brand info & test IDs
export const BRAND = {
  name: "Top-Notch Pro Solutions",              // marketing / display name
  legalName: "Top-Notch Pro Solutions LLC",     // legal entity — use in contracts, footer copyright, JSON-LD, invoices
  tagline: "Home Care & Property Improvement",
  phone: "(812) 708-0007",
  phoneHref: "tel:+18127080007",
  address: "235 N Burkhardt Rd #1084, Evansville, IN 47715",
  email: "topnotchprosolutions@gmail.com",
  hours: [
    { day: "Mon – Sat", time: "8:00 AM – 6:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  serviceArea: "20-mile radius around Evansville, IN",
  logoUrl: "https://customer-assets.emergentagent.com/job_site-launch-260/artifacts/88gggtkj_Messenger_creation_9D9201D3-10A3-4FAF-AA7B-8185DB72BC9A.png",
};
